import { type SanityColorValue } from '@data/sanity/queries/types/color'

// export const gridColorClasses: Record<SanityColorValue, string | string[]> = {}

export const textColorClasses: Record<SanityColorValue, string | string[]> = {
  white: 'text-white',
  black: 'text-black',
}
